import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/Users/wouter/prjs/wouter/krewebacchus/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/wouter/prjs/wouter/krewebacchus/layouts/default.vue").then(m => m.default || m))
}